import Opportunities from './Opportunities'
import Add from './OpportunitiesAdd'
import Show from './Show'
import Create from './Create'
import Costing from './Costing'
import CostingLine from './CostingLine'
import CreateUserStory from './CreateUserStory'
import Overview from './Overview'
import Quote from './Quote'
import Panda from './Panda'
import Documents from './Documents'
import DocumentSigning from './DocumentSigning'

export default {
    Opportunities,
    Add,
    Show,
    Create,
    Costing,
    CostingLine,
    CreateUserStory,
    Overview,
    Quote,
    Panda,
    Documents,
    DocumentSigning
}
